<template>
  <section class="commercial-products-form">
    <commercial-form
      :loading="loading"
      :sections="sections"
      :selected-store="selectedStore"
      :rule="financingProductRules.read.item"
      remove-action="financingProductRules/delete"
      @submit="submit"
      @removed="removed"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import former from '@/helpers/mixins/former';
  import scrollHelper from '@/helpers/views/scroll';

  import {
    productsSections as sections,
  } from '@/views/Settings/Commercial/Form/sections';

  import commercialMap, {
    storesMap,
    productsMap,
  } from '@/views/Settings/Commercial/Form/maps';

  import CommercialForm from '@/views/Settings/Commercial/Form.vue';

  export default {
    name: 'CommercialProductsForm',
    components: {
      CommercialForm,
    },
    mixins: [former],
    data() {
      return {
        // A loja da regra que esta tela abriu, para o seletor conseguir mostrá-la
        // mesmo quando ela está fora da página de lojas que o campo carregou.
        selectedStore: null,
        sections: sections(),
      };
    },
    computed: {
      ...mapState([
        'financingProductRules',
      ]),

      loading() {
        return this.financingProductRules.create.loading;
      },
    },
    mounted() {
      this.getProducts();
    },
    methods: {
      // A LOJA VEM DO CAMINHO - ver o comentário equivalente em `Returns/Form.vue`.
      getProducts() {
        const {
          id: storeID,
          rule_id: ruleID,
        } = this.$route.params;

        this.setFieldValue(storesMap.store_id, storeID);

        if (!ruleID) {
          // Criando não há regra - ver o comentário equivalente em `Returns/Form.vue`.
          this.$store.dispatch('financingProductRules/clear', { action: 'read' });

          return;
        }

        this.setFieldProcessingBulk(commercialMap, true);
        this.setFieldProcessingBulk(productsMap, true);

        this.$store
          .dispatch('financingProductRules/read', { id: ruleID })
          .then(this.gotReturn);
      },
      gotReturn() {
        const {
          store,
          store_id: storeID,
          vehicle_model: vehicleModel,
          bank,
          include_financial_protection_insurance: includeFinancialProtectionInsurance,
          include_capitalization_bond: includeCapitalizationBond,
          include_asset_insurance: includeAssetInsurance,
          include_personal_insurance: includePersonalInsurance,
        } = this.financingProductRules.read.item;

        this.selectedStore = store;
        this.setFieldValue(storesMap.store_id, storeID);
        this.setFieldValue(commercialMap.has_bank, !!bank);
        this.setFieldValue(commercialMap.has_vehicle, !!vehicleModel);

        if (bank) {
          this.setFieldValue(commercialMap.bank_id, bank.id);
        }

        if (vehicleModel) {
          this.setFieldValue(commercialMap.vehicle_model_id, vehicleModel.id);
        }

        this.setFieldValue(
          productsMap.include_financial_protection_insurance,
          !!includeFinancialProtectionInsurance,
        );

        this.setFieldValue(
          productsMap.include_capitalization_bond,
          !!includeCapitalizationBond,
        );

        this.setFieldValue(
          productsMap.include_asset_insurance,
          !!includeAssetInsurance,
        );

        this.setFieldValue(
          productsMap.include_personal_insurance,
          !!includePersonalInsurance,
        );

        this.setFieldProcessingBulk(commercialMap, false);
        this.setFieldProcessingBulk(productsMap, false);
      },
      submit() {
        const {
          rule_id: ruleID,
        } = this.$route.params;

        const payload = {
          store_id: this.getFieldValue(storesMap.store_id),
          bank_id: this.getFieldValue(commercialMap.bank_id),
          vehicle_model_id: this.getFieldValue(
            commercialMap.vehicle_model_id,
          ),
          include_financial_protection_insurance: this.getFieldValue(
            productsMap.include_financial_protection_insurance,
          ),
          include_capitalization_bond: this.getFieldValue(
            productsMap.include_capitalization_bond,
          ),
          include_asset_insurance: this.getFieldValue(
            productsMap.include_asset_insurance,
          ),
          include_personal_insurance: this.getFieldValue(
            productsMap.include_personal_insurance,
          ),
        };

        if (ruleID) {
          payload.id = ruleID;
        }

        this.$store
          .dispatch(`financingProductRules/${ruleID ? 'update' : 'create'}`, payload)
          .then(this.submitSuccess)
          .catch(this.submitFailure);
      },
      // De volta à listagem da loja em que a regra ficou - ver `Returns/Form.vue`.
      submitSuccess() {
        this.$router.push({
          name: 'stores-commercial-control-products',
          params: {
            id: this.getFieldValue(storesMap.store_id),
          },
        });
      },
      // A regra removida: a loja é a dela - ver `Returns/Form.vue`.
      removed(storeID) {
        this.$router.push({
          name: 'stores-commercial-control-products',
          params: {
            id: storeID,
          },
        });
      },
      submitFailure() {
        const {
          error,
        } = this.financingProductRules[this.$route.params.rule_id ? 'update' : 'create'];

        this.setErrors({
          ...storesMap,
          ...commercialMap,
          ...productsMap,
        }, error);

        scrollHelper();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
